// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2dE1a","title":"Info_title__jhxtO","selects":"Info_selects__2-HuN","requiredAsterisk":"Info_requiredAsterisk__1T05l"};